export function getLocalizedCountryName (countryCode: string, locale: string): string {
  if (!countryCode) return ''
  return new Intl.DisplayNames(locale, { type: 'region' }).of(countryCode) || countryCode
}
